import { Marker } from "@vis.gl/react-google-maps";

/**
 * Custom Map Marker Component
 *
 * This component wraps the `Marker` component from `@vis.gl/react-google-maps`,
 * allowing additional props to be passed directly. It is designed for flexibility
 * in reusing `Marker` with custom configurations.
 *
 * @param {Object} rest - Props passed to the `Marker` component.
 * @param {google.maps.LatLngLiteral | google.maps.LatLng} rest.position - The position of the marker.
 * @returns {JSX.Element} A custom Google Maps Marker component.
 */
export function MiMarker(rest) {
  return <Marker {...rest} />;
}
